var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMethodologies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.60596,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E0F2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 25.606V22.606C25 20.9491 23.6569 19.606 22 19.606C20.3431 19.606 19 20.9491 19 22.606C19 24.2628 20.3431 25.606 22 25.606H25ZM25 25.606V31.606M25 25.606H31M25 31.606V34.606C25 36.2628 23.6569 37.606 22 37.606C20.3431 37.606 19 36.2628 19 34.606C19 32.9491 20.3431 31.606 22 31.606H25ZM25 31.606H31M31 31.606H34C35.6569 31.606 37 32.9491 37 34.606C37 36.2628 35.6569 37.606 34 37.606C32.3431 37.606 31 36.2628 31 34.606V31.606ZM31 31.606V25.606M31 25.606V22.606C31 20.9491 32.3431 19.606 34 19.606C35.6569 19.606 37 20.9491 37 22.606C37 24.2628 35.6569 25.606 34 25.606H31Z",
    stroke: "#0086C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.60596,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F0F9FF",
    strokeWidth: 8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMethodologies);
export default __webpack_public_path__ + "static/media/Methodologies.74c926c0d513a435c41cd7c87ace63ed.svg";
export { ForwardRef as ReactComponent };